import { combineReducers } from 'redux';

import errors from './errors';
import global from './global';
import * as auth from './auth';
import * as menu from './menu';
import * as home from './home';

const rootReducer = combineReducers({
  errors,
  global,
  ...auth,
  ...menu,
  ...home,
});

export default rootReducer;
